import { applyColorMode, readColorMode, type ColorMode } from '@/utils/colorMode'

export function useDarkMode() {
    const colorMode = useState<ColorMode>('colorMode', () => 'system')
    const isDark = useState<boolean>('isDark', () => false)

    function updateDarkClass() {
        if (import.meta.client) {
            const systemDark = typeof window.matchMedia === 'function' && window.matchMedia('(prefers-color-scheme: dark)').matches
            isDark.value = applyColorMode(colorMode.value, systemDark)
        }
    }

    function initializeDarkMode() {
        if (import.meta.client) {
            colorMode.value = readColorMode()
            updateDarkClass()
        }
    }

    function setColorMode(mode: ColorMode) {
        colorMode.value = mode
        if (import.meta.client) {
            try {
                window.localStorage.setItem('colorMode', mode)
            } catch {
                // The selection still works when browser storage is unavailable.
            }
            updateDarkClass()
        }
    }

    function toggleDarkMode() {
        setColorMode(isDark.value ? 'light' : 'dark')
    }

    return {
        colorMode: readonly(colorMode),
        isDark: readonly(isDark),
        setColorMode,
        toggleDarkMode,
        initializeDarkMode,
        updateDarkClass
    }
}
